"use client";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import HeadingSize from "../ui/HeadingSize";

const ResponsivePicture = ({
  baseSrc,
  alt,
  className,
  layout = "fill",
}: {
  baseSrc: string;
  alt: string;
  className?: string;
  layout?: "fill" | "intrinsic";
}) => (
  <picture>
    <source srcSet={`${baseSrc}.webp`} type="image/webp" />
    <source srcSet={`${baseSrc}.png`} type="image/png" />
    <Image
      src={`${baseSrc}.webp`}
      alt={alt}
      fill={layout === "fill"}
      width={layout === "intrinsic" ? 800 : undefined}
      height={layout === "intrinsic" ? 600 : undefined}
      loading="lazy"
      placeholder="blur"
      blurDataURL="/images/placeholder.png"
      className={className}
    />
  </picture>
);

const GlobalMapSection = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-white w-full ">
      <div className=" py-2 md:py-0 ">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-4 mb-8 md:mb-4 lg:mb-0">
          <div className="w-full md:w-1/2 md:-ml-[5%]">
            <div className={"md:hidden relative aspect-[16/9] w-full px-4"}>
              <ResponsivePicture
                baseSrc="/images/home/worldmap-mobile"
                alt="Ryze Global Presence Map (Mobile)"
                className="object-contain border-0"
              />
            </div>
            <div
              className={
                "hidden md:block relative aspect-[4/3] max-h-[490px] 2xl:max-h-[570] w-[110%]"
              }
            >
              <ResponsivePicture
                baseSrc="/images/home/worldmap"
                alt="Ryze Global Presence Map (Desktop)"
                className="object-contain"
              />
            </div>
          </div>

          <div className="w-full md:w-1/2 px-4 md:px-8 lg:px-24 2xl:px-32 text-center md:text-left mt-8 md:mt-0">
            <div className="mb-6 md:mb-4 lg:mb-6">
              <HeadingSize text={t("home.ryzeAroundTheWorld")} />
            </div>
            <p className="text-[#000000] text-base sm:text-2xl md:text-[22px] lg:text-[28px] xl:text-[28px] 2xl:text-[32px] w-full md:max-w-2xl mx-auto md:mx-0 md:leading-normal 2xl:leading-normal">
              {t("home.globalPresenceText")}
            </p>
            <div className=" mt-4">
              <Link
                aria-label="learn more"
                href="/pages/science"
                data-test-id="learn-more-cta"
                className="inline-block"
              >
                <button
                  id="learn-more"
                  aria-label="learn-more"
                  className="bg-[#ff0000] text-white px-20 py-2 text-[22px] font-normal rounded-tl-[30px] rounded-br-[30px] min-w-[180px] hover:bg-[#8f000a] transition-colors"
                >
                  {t("common.learnMore")}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalMapSection;
